import React from "react";
import Modal from "../../../../elements/Modal";
import ManageEmailTemplate from "../ManageEmailTemplate";
import TemplateEditor from "../../../../elements/TemplateEditor/TemplateEditor";
import useMutation from "../../../../../hooks/useMutation";
import { emailTemplateAddEdit } from "../../../../../services/emailService";

const ManageEmailTemplateModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl4"
      title={data?._id ? "Update One" : "Create New"}
    >
      <ManageEmailTemplate
        getResponse={getResponse}
        close={close}
        data={data}
      />
    </Modal>
  );
};

export default ManageEmailTemplateModal;
